import { Avatar, Card, Text } from "@mantine/core";
import React from "react";
import { ExternalLink } from "react-feather";
import { Company } from "@lib/types/jobTypes";
import Link from "next/link";
import getCompanyUrl from "@lib/utils/url/getCompanyUrl";
import FatUnderlined from "@components/Various/FatUnderlined";

function CompactCompanyListing({ company }: { company: Company }) {
  return (
    <Card withBorder radius="md" p="md" data-test="compact-company-listing">
      <div className="flex gap-6">
        <div>
          {company.logo && (
            <Avatar
              src={company.logo as string}
              alt={company.name}
              className="rounded-full"
              size="xl"
            />
          )}
        </div>
        <div>
          <Link href={getCompanyUrl(company)} passHref legacyBehavior>
            <Text mb="md" className="text-lg" weight={700} component="a">
              <FatUnderlined>{company.name}</FatUnderlined>
            </Text>
          </Link>
          <Text mb="md" color="dimmed">
            {company.description}
          </Text>
          {company.website && (
            <a
              href={company.website}
              className="text-blue-500 flex items-center"
              target="_blank"
              rel="noreferrer"
            >
              <ExternalLink className="mr-1" size={15} /> {company.website}
            </a>
          )}
        </div>
      </div>
    </Card>
  );
}

export default CompactCompanyListing;
